export default __webpack_public_path__ + "static/media/chevron-down.b3db9c88.svg";